<template>
    <div class="Activities"
         :style="{ 'padding': isSchool && '0 10px' }">
        <tabs showBorderBottom
              :tabs-list="activitiesInfo"
              :active-tab="activeTab"
              @changed="changeTab">
            <component :is="activeTab"
                       :is-school="isSchool">
            </component>
        </tabs>
    </div>
</template>

<script>
    import * as _ from 'lodash';
    import * as types from '@/store/mutationTypes';
    import { mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        name: 'Activities',

        components: {
            Tabs: () => import(/* webpackChunkName: "activities" */ '@/components/controls/Tabs'),
            Policies: () => import(/* webpackChunkName: "activities" */ '@/components/dashboard/pages/Activities/Policies'),
            ClassList: () => import(/* webpackChunkName: "activities" */ '@/components/dashboard/pages/Activities/ClassList'),
            CampsList: () => import(/* webpackChunkName: "activities" */ '@/components/dashboard/pages/Activities/CampsList'),
            AftercareList: () => import(/* webpackChunkName: "activities" */ '@/components/dashboard/pages/Activities/AftercareList')
        },

        props: {
            isSchool: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                activeTab: ''
            }
        },

        computed: {
            ...mapGetters(['activitiesInfo'])
        },

        methods: {
            ...mapActions(['getLocations', 'resetPageOptions', 'getActivitiesInfo', 'getSchoolInfo']),

            ...mapMutations({
                updateSearch: types.UPDATE_SEARCH,
            }),

            changeTab(tabName) {
                this.activeTab = tabName;
                this.resetPageOptions();
            },

            setDefaultActiveTab() {
                if (!this.activeTab) {
                    this.activeTab = _.find(this.activitiesInfo, item => item.display).componentName;
                }
            }
        },

        beforeRouteEnter(to, from, next) {
            const { activeTab } = to.query;
            if (activeTab && ['ClassList', 'CampsList', 'AftercareList'].includes(activeTab)) {
                return next(vm => vm.activeTab = activeTab);
            }
            next();
        },

        async beforeMount() {
            await this.getSchoolInfo();
            await this.getActivitiesInfo();

            this.$nextTick();
            this.setDefaultActiveTab();
        },

        created() {
            const { activityType, search } = this.$router.currentRoute.query;
            
            if (activityType && search) {
                this.activeTab = activityType;
                this.updateSearch(search);
            }

            this.getLocations();
        },

        beforeDestroy() {
            this.resetPageOptions();
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../assets/styles/variables/colors';

    .Activities {
        background-color: $ComplementaryBackgroundLightGrey;
    }
</style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/Activities/Activities.vue